/**
 * Funções comuns ao aviso na tela do D1 e ao cartão da conversa do D2. Ficam fora dos arquivos
 * dos componentes (o Fast Refresh só vale para arquivo que exporta só componente) e fora do
 * `AvisoNaTela.tsx`, que importa o cartão — o cartão importar dele de volta seria um ciclo.
 */
import { formatDistanceToNow } from "date-fns";
import { ptBR } from "date-fns/locale";

/**
 * "agora" / "há 5 minutos": o tempo do rodapé do aviso. Menos de um minuto, ou data ilegível,
 * vira "agora" — o aviso acabou de chegar.
 */
export function quandoDoAviso(criadoEm: string): string {
  const data = new Date(criadoEm);
  if (Number.isNaN(data.getTime()) || Date.now() - data.getTime() < 60_000) return "agora";
  return formatDistanceToNow(data, { addSuffix: true, locale: ptBR });
}

/** Para onde o aviso de mensagem leva: a conversa aberta (a tela de mensagens lê `?sala=`). */
export function caminhoDaConversa(roomId: string): string {
  return `/mensagens?sala=${encodeURIComponent(roomId)}`;
}
